/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  AccessKeyPermissions,
  useGetApiKeysPermissionsQuery,
} from "~/generated/graphql";
import { Merge } from "~/tools";

type KeyPermissionsApiResponse = NonNullable<
  ReturnType<typeof useGetApiKeysPermissionsQuery>["data"]
>;
type ApiAccessPermissionsItem = NonNullable<
  NonNullable<
    KeyPermissionsApiResponse["accessKeysPermissions"]
  >["keyPermissions"]
>[number];

type ApiKeyPermissions = Merge<ApiAccessPermissionsItem>;

export function mapApiKeyPermissions(
  apiKeysPermissions: ApiAccessPermissionsItem
): AccessKeyPermissions {
  const apiKeyPermissions: ApiKeyPermissions =
    apiKeysPermissions as ApiKeyPermissions;
  return {
    isExpired: apiKeyPermissions.isExpired ?? false,
    expirationDate: apiKeyPermissions.expirationDate ?? "",
    createdAt: apiKeyPermissions.createdAt ?? "",
    id: apiKeyPermissions.id,
    access: {
      role: apiKeyPermissions.access.role,
      applications: apiKeyPermissions.access.applications ?? [],
      applicationsWithNames:
        apiKeyPermissions.access.applicationsWithNames ?? [],
    },
    description: apiKeyPermissions.description ?? "",
  };
}
